import * as React from 'react';
import { GridPaginationListViewModelImpl } from '../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ToneCardPlayerCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonecardplayercss';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneRowOptionsPrivilage } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ToneMobileCardPlayerCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';
import { ToneCardComponent } from '../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { ToneEvenCardCSSStyleImpl } from '../featuredcategory/viewmodel/tonecard/toneevencardcssstyle';
import { SearchListToneCardPlayerCSSStyleImpl } from '../searchlist/searchlisttonecardplayercss';

// import { ToneMobileCardPlayerCSSStyleImpl } from './tonecard/tonemobilecardplayercss';

export class CategoryToneListViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    
    
    private playerCSSStyle: ToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;
  
    constructor(offset: string, private audioPlayerWithProgress: AudioPlayerWithProgress, private toneRowOptionsPrivilage: ToneRowOptionsPrivilage, context: BaseContext, private marginTop: string, title: string)
    {
        super(offset,context);
        this.onToneSelected = this.onToneSelected.bind(this);
        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ToneCardComponent  mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle}  playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    

    setAudioProgress(): void
    {
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(this.getContext().getPlayerManager().getAudioPlayer());
    }
    protected onToneSelected(): void
    {
       
    }

  
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/landingpagelist/landingpagelistviewmodel.tsx